import { useCallback, MouseEvent, ReactElement } from "react";

export function SubmitButton({
  canSubmit,
  onSubmit,
  submitButtonText,
}: {
  canSubmit: boolean;
  onSubmit: () => void;
  submitButtonText: string;
}): ReactElement {
  const handleClick = useCallback(
    (event: MouseEvent<HTMLInputElement>) => {
      event.preventDefault();
      onSubmit();
    },
    [onSubmit]
  );

  return (
    <input
      type="submit"
      onClick={handleClick}
      value={submitButtonText}
      disabled={!canSubmit}
    />
  );
}
